import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import { OnboardingFormFields } from '@Types/index';
import type { IBusinessAdress } from '@Types/address';

export const getOperationalAddress = async () => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/address/operational`
    : `v2/secureonboarding/user/${customerId}/business/address/operational`;

  const { data } = await HttpService.get(url);
  return data;
};

export const updateBusiness = async (props: IBusinessAdress) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/setBusinessAddress`
    : `v2/secureonboarding/user/${customerId}/setBusinessAddress`;

  try {
    const { data } = await HttpService.post(url, {
      line1: props[OnboardingFormFields.LINE1],
      line2: props[OnboardingFormFields.APARTMENT],
      city: props[OnboardingFormFields.CITY],
      state: props[OnboardingFormFields.STATE]?.value,
      postalCode: props[OnboardingFormFields.ZIP],
      country: props[OnboardingFormFields.COUNTRY]?.code,
      sameAsPrimary: props[OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY],
    });
    return data;
  } catch (error) {
    throw error;
  }
};
